import React, { Component } from 'react';
import { connect } from 'react-redux';
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css"
import './../css/notifications.css';
import { getNotification } from "../services/notificationservice";
import moment from 'moment';
import Header from '../components/header';
import UserMenu from './userMenu';


class Notifications extends Component {
    constructor(props) {
        super(props);
        this.state = {
            notifications: [],
            from: "",
            to: ""
        };
    }

    componentDidMount() {
        let curDate = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
        let weekDate = new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
        this.setState({ to: curDate, from: weekDate }, () => {
            this.getNotifications();
        })

    }
    getNotifications() {
        const data = `fromDate=${new Date(this.state.from).toISOString()}&toDate=${new Date(this.state.to).toISOString()}`;
        this.setState({ loader: true, showData: false, notifications: [] });
        getNotification(data).then((res) => {
            if (res && res.isSuccess === true) {
                this.setState({ notifications: res.items, loader: false, showData: true });
            }
        });
    }
    onDateTimeChange(name, e) {
        this.setState({ [name]: e._d })
    }
    formatDateTime(dateTimeString) {
        const normalized = (dateTimeString?.includes(' ')
            ? dateTimeString.replace(' ', 'T')
            : dateTimeString) + ".000+00:00";

        const date = new Date(normalized);

        const day = String(date.getDate()).padStart(2, '0');
        const month = date.toLocaleString('en-US', { month: 'long' });
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        return {
            day,
            monthYear: `${month} ${year}`,
            timeFormatted: moment(`${hours}:${minutes}:${seconds}`, "HH:mm:ss").format("hh:mm:ss A")
        };
    }

    updateNotiList(data) {
        const nw = Date.now();
        if (!!data && nw >= this.state.from && nw <= this.state.to) {
            this.setState((prevState) => ({
                notifications: [data, ...prevState.notifications]
            }));
        }
    }


    render() {
        const { notifications } = this.state;

        return (
            <div className="radheexch">
                <Header notify={this.props.notify} showSweetAlert={(options) => this.props.showSweetAlert(options)} MySwal={this.props.MySwal} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} history={this.props.history} socket={this.props.socket} updateNotiList={(data) => this.updateNotiList(data)} />
                <div className="full-wrap">
                    <UserMenu history={this.props.history} isMaintanance={this.state.isMaintanance} />
                    <div className="col-center1 markets">
                        <div className="mar-top100">
                            <div className="sub_path center-box mt-2">
                                <p>Notifications</p>
                            </div>
                            <div className="allreport col3">
                                <div className="row mx-0">
                                    <div className="col-12 col-sm-6 col-md-3 col-lg-2 mt-2">
                                        <div className="form-group font-12">
                                            <Datetime
                                                value={this.state.from}
                                                onChange={(e) => this.onDateTimeChange("from", e)}
                                                id="from_datetime"
                                                dateFormat={"DD/MM/YYYY"}
                                                timeFormat={"HH:mm"}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-3 col-lg-2 mt-2">
                                        <div className="form-group font-12">
                                            <Datetime
                                                value={this.state.to}
                                                onChange={(e) => this.onDateTimeChange("to", e)}
                                                id="to_datetime"
                                                dateFormat={"DD/MM/YYYY"}
                                                timeFormat={"HH:mm"}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-3 col-lg-2 mt-2">
                                        <div className="btn-group" role="group" aria-label="Basic example" id="divpagecount">
                                            <button className="btn place-bet-btn" onClick={(e) => this.getNotifications(e)}>Go</button>
                                        </div>
                                    </div>
                                </div>
                                {!!this.state.loader ? <div className={"ml-2"}>Loading......</div> : null}
                                {!!this.state.showData && notifications.length === 0 ? <div className={"ml-2 mt-2"}>No Notifications Found</div> :
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 mt-1 px-2 notification-mobile-pd">
                                        {
                                            notifications.map((notification, index) => {
                                                return (
                                                    <div key={index} className="notification-row">
                                                        {/* Date/Time Box */}
                                                        <div className="notification-datetime-box">
                                                            <div className="notification-day">
                                                                {this.formatDateTime(notification.createdAt).day}
                                                            </div>
                                                            <div className="notification-separator"></div>
                                                            <div className="notification-month-year">
                                                                {this.formatDateTime(notification.createdAt).monthYear}
                                                            </div>
                                                        </div>

                                                        {/* Header & Description Box */}
                                                        <div className="notification-content-box">
                                                            <div className="notification-header-wrapper">
                                                                <div className="notification-header"
                                                                    dangerouslySetInnerHTML={{ __html: notification.title }}>
                                                                </div>
                                                                <div className="notification-time">
                                                                    {this.formatDateTime(notification.createdAt).timeFormatted}
                                                                </div>
                                                            </div>
                                                            <div className="notification-description"
                                                                dangerouslySetInnerHTML={{ __html: notification.body }}>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);